import { useState } from "react";

import TextInput from "./input/text-input";
import { useFindPath } from "../hooks/useFindPath";
import { useNavigationStore } from "src/store/navigationStore";
import ImageButton from "./button/image-button";
import { CHAT_TYPE } from "./../types/navigation-mode";
import { useNavigate } from "react-router-dom";
import { useCrimeSceneStore } from "@/store/crimeSceneStore";
import { CRIME_SCENE_STEPS } from "@/const/crimeSceneConst";
import { useLanguageStore } from "@/store/languageStore";

interface NavFormProps {
  placeholder?: string;
  onSubmit?: Function;
  fromChat?: boolean;
  redirectToNav?: boolean;
  inputWithBorder?: boolean;
  chatType: string;
}

const NavForm: React.FC<NavFormProps> = ({
  placeholder = "",
  onSubmit,
  fromChat = false,
  redirectToNav = false,
  inputWithBorder = false,
  chatType,
}) => {
  const [query, setQuery] = useState("");
  const { handleUserQuery } = useFindPath(redirectToNav);
  const setUserQuery = useNavigationStore((state) => state.setUserQuery);
  const setInterrupt = useNavigationStore((state) => state.setInterrupt);
  const setCrimeSceneSteps = useCrimeSceneStore(
    (state) => state.setCrimeSceneSteps
  );
  let navigate = useNavigate();
  const useCurrentLocation = useNavigationStore(
    (state) => state.useCurrentLocation
  );

  const startVenueId = useNavigationStore((state) => state.startVenueId);
  const startMapId = useNavigationStore((state) => state.startMapId);
  const startCoordinate = useNavigationStore((state) => state.startCoordinate);
  const startPoi = useNavigationStore((state) => state.startPoi);
  const setVoiceOn = useLanguageStore((state) => state.setVoiceOn);

  const onSend = async (value: string) => {
    console.log("onSend: value=", value);

    if (value) {
      if (onSubmit != null) {
        onSubmit();
      }

      setInterrupt(true);
      if (CHAT_TYPE.NAVIGATION === chatType) {
        setVoiceOn(false);
        await handleUserQuery(value, {
          useCurrentLocation: useCurrentLocation,
          startVenueId: startVenueId,
          startMapId: startMapId,
          startCoordinate: startCoordinate,
          startPoi: startPoi
        });
      } else if (CHAT_TYPE.SIMULATION === chatType) {
        setUserQuery(value);
        setVoiceOn(true);
        setCrimeSceneSteps(CRIME_SCENE_STEPS);
        navigate("/simulation/chat");

        // navigate("/simulation");
      }
    }
  };

  return (
    <div className="flex flex-col justify-end">
      <div className="">
        <TextInput
          placeholder={placeholder}
          value={query}
          onChange={(keyword) => {
            setQuery(keyword);
          }}
          onSubmit={async () => {
            await onSend(query);
            setQuery("");
          }}
          withBorder={inputWithBorder}
        />
      </div>
      <div className={`flex ${fromChat ? "justify-end" : ""}`}>
        <ImageButton
          aria-hidden
          className="mr-[10px] btn-send"
          src="/assets/icon_next.png"
          alt="icon"
          size={20}
          onClick={async () => {
            await onSend(query);
            setQuery("");
          }}
        />
      </div>
    </div>
  );
};

export default NavForm;
